import { render, staticRenderFns } from "./Result.vue?vue&type=template&id=6c1be9d2&scoped=true"
import script from "./Result.vue?vue&type=script&lang=js"
export * from "./Result.vue?vue&type=script&lang=js"
import style0 from "./Result.vue?vue&type=style&index=0&id=6c1be9d2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1be9d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c1be9d2')) {
      api.createRecord('6c1be9d2', component.options)
    } else {
      api.reload('6c1be9d2', component.options)
    }
    module.hot.accept("./Result.vue?vue&type=template&id=6c1be9d2&scoped=true", function () {
      api.rerender('6c1be9d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/SearchModal/Result.vue"
export default component.exports